// ✅ Trekkin.app — PanelShell.jsx v3.7.3 (SAFE PROPS + PRESERVE MODE)
// -----------------------------------------------------------------------------
// ✔ Mantém TODO o comportamento do v3.7.2
// ✔ Se preserve=true → o painel NÃO desmonta ao regressar
// ✔ FIX DEFINITIVO React #31:
//     • Nunca espalha props inválidas
//     • Protege contra objetos { type, message }
//     • Logs de debug para detetar origem do problema
// ✔ NÃO altera layout, UX ou stacking
// -----------------------------------------------------------------------------

import { Suspense } from "react";
import { usePanelsStore } from "../stores/usePanelsStore";
import LoadingDotsOverlay from "./LoadingDotsOverlay.jsx";
import { PANEL_COMPONENTS, PANEL_FALLBACK } from "./panelRegistry.jsx";

export default function PanelShell({ children = null }) {
  const { currentPanel, closePanel } = usePanelsStore();

  if (!currentPanel) return null;

  const PanelComponent =
    PANEL_COMPONENTS[currentPanel.name] || PANEL_FALLBACK;
  const preserve = currentPanel?.props?.preserve === true;
  const allowMapInteraction = currentPanel.name === "mapSelectPoint";

  // -------------------------------------------------------------
  // VIEWER MODE (?share=) — nunca mostrar painéis
  // -------------------------------------------------------------
  const isViewer = (() => {
    try {
      return new URLSearchParams(window.location.search).has("share");
    } catch {
      return false;
    }
  })();

  if (isViewer) return null;

  // -------------------------------------------------------------
  // 🛡️ SAFE PROPS (FIX React error #31)
  // -------------------------------------------------------------
  const rawProps = currentPanel?.props;

  const safeProps =
    rawProps && typeof rawProps === "object" && !Array.isArray(rawProps)
      ? rawProps
      : {};

  // 🧪 DEBUG — identificar props perigosas
  if (
    safeProps &&
    typeof safeProps === "object" &&
    ("type" in safeProps || "message" in safeProps)
  ) {
    console.warn(
      "🚨 [PanelShell] Props potencialmente perigosas recebidas:",
      safeProps,
      "Painel:",
      currentPanel.name
    );
  }

  // -------------------------------------------------------------
  // RENDER
  // -------------------------------------------------------------
  return (
    <div
      className={`panel-shell-wrapper${currentPanel.name === "admin" ? " panel-shell-admin" : ""}`}
      onPointerDown={(event) => {
        if (allowMapInteraction || event.target !== event.currentTarget) return;
        closePanel();
      }}
      style={{
        position: "absolute",
        inset: 0,
        display: "flex",
        justifyContent: "center",
        pointerEvents: allowMapInteraction ? "none" : "auto",
        zIndex: 2000,
      }}
    >
      <div
        className={currentPanel.name === "admin" ? "panel-shell-admin-scroll" : undefined}
        style={{
          position: "absolute",
          bottom: "calc(80px + env(safe-area-inset-bottom))",
          left: "10px",
          right: "10px",
          maxWidth: "520px",
          margin: "0 auto",
          maxHeight: "calc(100dvh - 170px)",
          overflowY: "auto",
          WebkitOverflowScrolling: "touch",
          overscrollBehaviorY: "contain",
          padding: "10px",
          backdropFilter: "blur(14px)",
          background: "var(--tk-panel-bg, rgba(255,255,255,0.85))",
          boxShadow: "var(--tk-panel-shadow, 0 4px 18px rgba(0,0,0,0.18))",
          color: "var(--tk-text, #17221b)",
          borderRadius: "18px",
          transition: "bottom 0.28s ease",
          pointerEvents: "auto",
        }}
      >
        <div className="tk-panel-content">
          <Suspense fallback={<LoadingDotsOverlay zIndex={2100} />}>
            {children || (
              <PanelComponent
                key={`${currentPanel.name}${preserve ? "-preserve" : ""}`}
                {...safeProps}
              />
            )}
          </Suspense>
        </div>
      </div>
    </div>
  );
}
